exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CopyrightNotice.inverted{color:hsla(0,0%,100%,.95)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/ta-react-copyright-notice/style/CopyrightNotice.css
// module id = 74
// module chunks = 0